import React, { Component } from 'react';
import { createBrowserHistory } from 'history';
import queryString from 'query-string';
// import moment from 'moment';
import { humanize, getBoxSides } from '../../box-helpers';

import {
    Container,
    FormGroup,
    Input,
    Col,
    Alert,
    Button,
    Row,
    Form,
    Label,
    UncontrolledTooltip
} from 'reactstrap';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import Switch from "react-switch";
import { ToastContainer } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { faSync, faArrowLeft} from '@fortawesome/pro-solid-svg-icons';

import {getValidEnclosureTypes} from '../../box-helpers';
import BoxConfigurationReservation from './BoxConfigurationReservation';
import QuickOrderModal from './QuickOrderModal';
import PdfPreview from '../Layout/PdfPreview';
// import { BorderLeft } from '@material-ui/icons';
import OAuthService from '../Auth/OAuthService';

class CustomerBoxConfigurationForm extends Component {
  state = {
    loading: false,
    alertMsg: "",
    formSubmitted: false,
    showSuccess: false,
    successMsg: "",
    showAlert: false,
    collapse: false,
    boxTypes: getValidEnclosureTypes(),
    boxSides: getBoxSides(),
    colors: [],
    usePredrilledEnclosure: false,
    box_designs: [], box_uv_designs: [],
    enclosureProducts: [],
    drillProducts: [],
    uvProducts: [],
    serviceProducts: [],
    uvServiceProducts: [],
    enclosureServiceProducts: [],
    drillServiceProducts: [],
    selectedEnclosureServiceProducts: [],
    boxConfigurationId: "",
    configurationName: "",
    boxType: "",
    powderColor: "",
    selectedEnclosureProduct: {id: "", name: "", img: ""},
    selectedDrillDesign: {id: "", name: ""},
    addDrillServices: false,
    addUVPrintServices: false,
    uvSidesCount: 1,
    selectedDrillProducts: [{id: null}],
    selectedUVPrints: [{id: null}],
    selectedProducts: [],
    reservedConfigurations: [],
    readyToSave: false,

    orderBoxJob: false,
    readyToOrder: false,
    box_configuration: null,
    openOrderModal: false,
    qty: 1,
    separateProducts: false,
    warningMsg: ''
  }

  constructor(props) {
    super(props);

    this.os = new OAuthService();
  }

  componentDidMount = () => {
    // Check if box_configuration_id is passed in the URL
    // If so, fetch the box configuration and set the state
    // If not, set the state to default values
    const parsed = queryString.parse(window.location.search);
    if(parsed.id){
      this.setState({
          loading: true
      }, () => {
          this.setBoxConfiguration(parsed.id)
      })
    }
    if (parsed.orderBoxJob) {
      this.setState({ orderBoxJob: true });
    }

  }


  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleCheckBoxesChange = (e) => {
    if(e.target.checked){
      this.setState({
        [e.target.name]: e.target.checked
      })
    }else{
      var curr_selectedProducts = JSON.parse(JSON.stringify(this.state.selectedProducts));
      if(e.target.name === "addDrillServices"){
        var drill_prodcuts = curr_selectedProducts.filter(p => p.is_drill_product === true && !p.is_predrill)
        var new_curr_selectedProducts = curr_selectedProducts.filter(a => !drill_prodcuts.includes(a))
        curr_selectedProducts = new_curr_selectedProducts

        this.setState({
          selectedProducts: curr_selectedProducts
        })

      }else if(e.target.name === "addUVPrintServices"){
        var uv_products = curr_selectedProducts.filter(p =>  p.is_uv_product === true)
        var new_curr_selectedProducts = curr_selectedProducts.filter(a => !uv_products.includes(a))
        curr_selectedProducts = new_curr_selectedProducts

        this.setState({
          selectedProducts: curr_selectedProducts,
          uvSidesCount: 1
        })
      }
      this.setState({
        [e.target.name]: e.target.checked,
      })
    }
  }

  handleUsePredrilledEnclosureChange = (new_switch_state) => {
    this.setState({
      usePredrilledEnclosure: new_switch_state,
    }, () => {
      this.handleEnclosureChange(null);
    })
  }

  handleAddDrillServicesChange = (new_switch_state) => {
    if(new_switch_state){
      this.setState({
        addDrillServices: new_switch_state,
        selectedDrillDesign: {id: "", name: ""}
      })
    }else{
      var curr_selectedProducts = JSON.parse(JSON.stringify(this.state.selectedProducts));
      var drill_prodcuts = curr_selectedProducts.filter(p => p.is_drill_product === true && !p.is_predrill)
      var new_curr_selectedProducts = curr_selectedProducts.filter(a => !drill_prodcuts.includes(a))

      this.setState({
        addDrillServices: new_switch_state,
        selectedProducts: new_curr_selectedProducts,
        selectedDrillDesign: {id: "", name: ""}
      })
    }
  }

  handleAddUVPrintServicesChange = (new_switch_state) => {
    if(new_switch_state){
      this.setState({
        addUVPrintServices: new_switch_state,
        selectedUVPrints: [{id: null}]
      }, () => {
        var box_uv_designs = this.getUVOptions();
        if(box_uv_designs.length === 1){
          this.handleUVPrintChangeSelect({value: box_uv_designs[0].value, label: box_uv_designs[0].box_side, name: "uvPrint" }, 0);
        }
      })
    }else{
      var curr_selectedProducts = JSON.parse(JSON.stringify(this.state.selectedProducts));
      var uv_products = curr_selectedProducts.filter(p =>  p.is_uv_product === true)
      var new_curr_selectedProducts = curr_selectedProducts.filter(a => !uv_products.includes(a))
      curr_selectedProducts = new_curr_selectedProducts

      this.setState({
        selectedProducts: curr_selectedProducts,
        uvSidesCount: 1,
        addUVPrintServices: new_switch_state,
        selectedUVPrints: [{id: null}]
      })
    }
  }

  handleBoxTypeChangeSelect = (val) => {
    if(val == null){
      this.setState({
        boxType: "",
        powderColor: "",
        selectedEnclosureProduct: {id: "", name: "", img: ""},
        selectedDrillDesign: {id: "", name : ""},
        colors: [],
        box_designs: [],
        box_uv_designs: [],
        enclosureProducts: [],
        addDrillServices: false,
        addUVPrintServices: false,
        uvSidesCount: 1,
        selectedProducts: [],
        selectedDrillProducts: [{id: null}],
        selectedUVPrints: [{id: null}],
        selectedEnclosureServiceProducts: [],
      })
    }else{
      if (val.value) {
        this.setState({
          boxType: val.value,
          powderColor: "",
          selectedEnclosureProduct: {id: "", name: "", img: ""},
          selectedDrillDesign: {id: "", name : ""},
          colors: [],
          box_designs: [],
          box_uv_designs: [],
          enclosureProducts: [],
          addDrillServices: false,
          addUVPrintServices: false,
          uvSidesCount: 1,
          selectedProducts: [],
          selectedDrillProducts: [{id: null}],
          selectedUVPrints: [{id: null}],
          selectedEnclosureServiceProducts: [],
        })
        this.getPowderColorsAndSkus(val.value);
      }
    }
  }

  handlePowderColorChangeSelect = (val) => {
    if(val == null){
      this.setState({
        powderColor: "",
        selectedEnclosureProduct: {id: "", name: "", img: ""},
        selectedDrillDesign: {id: "", name : ""},
        enclosureProducts: [],
        uvSidesCount: 1,
        addDrillServices: false,
        addUVPrintServices: false,
        selectedProducts: [],
        selectedUVPrints: [{id: null}],
        selectedEnclosureServiceProducts: [],
      })
      return
    }else{
      let value = val.value
      if (value) {
        this.setState({
          powderColor: value,
          selectedEnclosureProduct: {id: "", name: "", img: ""},
          selectedDrillDesign: {id: "", name : ""},
          enclosureProducts: [],
          uvSidesCount: 1,
          addDrillServices: false,
          addUVPrintServices: false,
          selectedProducts: [],
          selectedEnclosureServiceProducts: [],
          selectedUVPrints: [{id: null}],
        })
        this.fetchAvailableProducts(this.state.boxType, value);
      }
    }
  }

  handleClick = (e) => {
    this.setState({ readyToSave: true, showSuccess: false });

    if (this.state.configurationName !== "") {
      this.handleSubmit(e);
    } else {
      this.setState({ alertMsg: "Please enter a configuration name", showAlert: true, showSuccess: false });
    }
  }

  setBoxConfiguration = async (id) => {
    // console.log('get box_configuration id', id);
    var result =  await this.submitGetRequest(process.env.REACT_APP_API_URL + '/api/v4/box_configurations/' + id);

    if(result["errors"]){
      console.log('result error: ',result["errors"]);
      let errors = "";
      if (typeof result["errors"] === 'string') {
        errors = result["errors"];
      } else {
        errors = Object.keys(result["errors"]).map(key => {
          let human_key = humanize(key);
          return  human_key + " " + result["errors"][key];
        })
      }
      this.setState({ alertMsg: errors, showAlert: true, showSuccess: false, loading: false})
    }else{
      var box_configuration = result["box_configuration"];
      // console.log('box_configuration', box_configuration);
      if (box_configuration) {
        let selectedEnclosureProduct = {id: box_configuration.product.id, name: box_configuration.product.sku + " " + box_configuration.product.name, img: box_configuration.product.small_image_url}
        this.setState({
          boxConfigurationId: box_configuration.id,
          configurationName: box_configuration.name,
          boxType: box_configuration.enclosure_type,
          powderColor: box_configuration.powder_color,
          selectedEnclosureProduct: selectedEnclosureProduct,
          readyToSave: true,
          // selectedDrillDesign: {id: "", name : ""},
          // uvSidesCount: 1,
          // addDrillServices: false,
          // addUVPrintServices: false,
          // selectedProducts: [],
          // selectedUVPrints: [{id: null}],
        }, () => {
          // Set the selected products and selected drill products and design ids
          let {selectedProducts, uvSidesCount, addDrillServices, addUVPrintServices, selectedDrillDesign} = this.state;
          let selectedUVPrints = [];
          let selectedDrillProducts = [];
          let reservedConfigurations = [];
          let selectedEnclosureServiceProducts = [];

          //selectedProducts.push(selectedEnclosureProduct);
          let cur_selected_enclosure_products = box_configuration.products.filter(p => p.enclosure_type === this.state.boxType && p.powder_color && p.powder_color !== '');
          if(cur_selected_enclosure_products.length > 0){
            selectedProducts.push(cur_selected_enclosure_products[0]);
          }

          box_configuration.box_configuration_items.forEach(item => {

            var curr_item = item.product
            if(item.design){
              curr_item.TEMPLATE_SELECT = item.design
            }

            if (item.product_type === "drill") {
              selectedDrillDesign = {id: item.design_id, name: item.design.name, required_drill_holes: item.design.required_drill_holes || 0}
              addDrillServices = true;
              selectedDrillProducts.push({id: item.product.id});

              // Load drill services (like extra holes)
              curr_item.SERVICE_SELECT = [];
              if (item.box_configuration_item_services && item.box_configuration_item_services.length > 0) {
                item.box_configuration_item_services.forEach(service => {
                  // Include quantity from the service record
                  const serviceProduct = {
                    ...service.product,
                    qty: service.quantity || 1
                  };
                  curr_item.SERVICE_SELECT.push(serviceProduct);
                });
              }
            } else if (item.product_type === "uv") {
              uvSidesCount += 1;
              addUVPrintServices = true;
              let selectedUvServices = [];

              curr_item.SERVICE_SELECT = [];
              item.box_configuration_item_services.forEach(service => {
                selectedUvServices.push({product_id: service.product.id, service_type: service.service_type});
                curr_item.SERVICE_SELECT.push(service.product);
              });

              // Load has_gloss and has_white from saved item
              curr_item.has_gloss = item.has_gloss || false;
              curr_item.has_white = item.has_white || false;
              curr_item.has_color = item.has_color || false;

              var uv_print = item.product;
              if(item.design){
                uv_print.TEMPLATE_SELECT = item.design;
              }
              // Include has_gloss and has_white in the uv_print object
              uv_print.has_gloss = item.has_gloss || false;
              uv_print.has_white = item.has_white || false;
              uv_print.has_color = item.has_color || false;
              selectedUVPrints.push(uv_print); // services: selectedUvServices
            } else if (item.product_type === "enclosure") {
              // Load enclosure services
              if (item.box_configuration_item_services && item.box_configuration_item_services.length > 0) {
                item.box_configuration_item_services.forEach(service => {
                  // Include attribute_value from the service record if present
                  const serviceProduct = {
                    ...service.product,
                    attribute_value: service.attribute_value || ''
                  };
                  selectedEnclosureServiceProducts.push(serviceProduct);
                  // Also add to selectedProducts so they show in Needed Products section
                  selectedProducts.push(serviceProduct);
                });
              }
              // Don't push curr_item to selectedProducts - enclosure product is already added above
              return;
            }
            selectedProducts.push(curr_item);
          });

          box_configuration.reserved_configurations.forEach(item => {
            reservedConfigurations.push(item);
          });
          // console.log('selectedProducts', selectedProducts);
          this.setState({ selectedProducts, uvSidesCount, addDrillServices, addUVPrintServices, selectedDrillProducts, selectedUVPrints, selectedDrillDesign, reservedConfigurations, selectedEnclosureServiceProducts });
          this.fetchAvailableProducts(box_configuration.enclosure_type, box_configuration.powder_color);
          this.getPowderColorsAndSkus(box_configuration.enclosure_type);
        });
      }
    }
  }

  // state.colors holds { enclosure_type, powder_color, sku } objects, but tolerate
  // plain color strings too. The option value is always the powder color alone -
  // the sku is only shown in the label ("Black - A-5157" selects "Black").
  getColorOptions = () => {
    const colors = Array.isArray(this.state.colors) ? this.state.colors : [];
    const seen = {};
    const options = [];

    colors.forEach((color) => {
      const powder_color = typeof color === 'string' ? color : (color && color.powder_color);
      if (typeof powder_color !== 'string' || powder_color.trim() === "") {
        return;
      }

      const key = powder_color.trim().toUpperCase();
      if (seen[key]) {
        return;
      }
      seen[key] = true;

      const sku = (color && typeof color === 'object' && typeof color.sku === 'string') ? color.sku.trim() : "";
      options.push({
        value: powder_color,
        label: sku !== "" ? powder_color.trim() + " - " + sku : powder_color.trim()
      });
    });

    return options;
  }

  getColorLabel = (powder_color) => {
    if (typeof powder_color !== 'string' || powder_color === "") {
      return "";
    }
    const key = powder_color.trim().toUpperCase();
    const option = this.getColorOptions().find((o) => String(o.value).trim().toUpperCase() === key);
    return option ? option.label : powder_color;
  }

  getEnclosureProduct = () => {
    var enclosure_product = this.state.enclosureProducts.filter(a => a.is_predrill === this.state.usePredrilledEnclosure || (a.is_predrill == null && !this.state.usePredrilledEnclosure))
    return enclosure_product.map((t) => ({ value: t.id, label: t.sku + " " + t.name, name: "enclosureProduct", img: t.small_image_url, obj: t }))
  }

  handleEnclosureChange = (val) => {
    var enclosure_product = this.state.enclosureProducts.filter(a => a.is_predrill === this.state.usePredrilledEnclosure || (a.is_predrill == null && !this.state.usePredrilledEnclosure))

    if(val == null){
      if (this.state.boxConfigurationId === "") {
        this.setState({
          selectedEnclosureProduct: enclosure_product.length === 1 ? {id:  enclosure_product[0].id, name: enclosure_product[0].sku + " " + enclosure_product[0].name, img: enclosure_product[0].small_image_url} : {id: "", name: "", img: ""},
          selectedDrillDesign: {id: "", name : ""},
          uvSidesCount: 1,
          addDrillServices: false,
          addUVPrintServices: false,
          selectedProducts: enclosure_product.length == 1 ? [enclosure_product[0]] : [],
          selectedDrillProducts: [{id: null}],
          selectedUVPrints: [{id: null}],
          selectedEnclosureServiceProducts: [],
        })
      }
    }else{
      if (val.value) {
        this.setState({
          selectedEnclosureProduct: {id: val.value, name: val.label, img: val.img},
          selectedDrillDesign: {id: "", name : ""},
          uvSidesCount: 1,
          addDrillServices: false,
          addUVPrintServices: false,
          selectedProducts: [val.obj],
          selectedDrillProducts: [{id: null}],
          selectedUVPrints: [{id: null}],
          selectedEnclosureServiceProducts: [],
        })
      }
    }
  }

  handleAddDrillServicesCheckboxesChange = (e, id) => {
    if(e.target.checked){
      var drill_product_index = this.state.drillProducts.findIndex(a => a.id == id);
      if(drill_product_index != -1){
        var curr_selectedProducts = JSON.parse(JSON.stringify(this.state.selectedProducts));
        curr_selectedProducts.push(this.state.drillProducts[drill_product_index])
        this.setState({
          selectedProducts: curr_selectedProducts,
          selectedDrillDesign: {id: "", name : ""}
        })
      }
    }else{
      var curr_selectedProducts = JSON.parse(JSON.stringify(this.state.selectedProducts));
      var drill_product_index = curr_selectedProducts.findIndex(a => a.id == id);
      if(drill_product_index != -1){
        curr_selectedProducts.splice(drill_product_index, 1);
        this.setState({
          selectedProducts: curr_selectedProducts,
          selectedDrillDesign: {id: "", name : ""}
        })
      }
    }
  }

  getDrillDesign = () => {
    var selected_drill_prodcuts = this.state.selectedProducts.filter(p => p.is_drill_product === true && !p.is_predrill)
    var box_designs = []
    let noDesignName = "No Drill Design Available. Create A Design First";
    if(selected_drill_prodcuts.length > 1){
      box_designs = this.state.box_designs.filter(b => b.has_lid === true)
      noDesignName += " (With Lid)";
    }else if(selected_drill_prodcuts.length === 1){
      if(selected_drill_prodcuts[0].is_lid_product === true){
        noDesignName += " (With Lid)";
        box_designs = this.state.box_designs.filter(b => b.lid_only === true)

      }else if(selected_drill_prodcuts[0].is_lid_product === null || selected_drill_prodcuts[0].is_lid_product === false){
        box_designs = this.state.box_designs.filter(b => b.has_lid === false)
      }
    }
    if (box_designs.length === 0){
      box_designs = [{ id: "", name: noDesignName, value: "", obj: { id: "", name: "No Drill Design Available" } }];
    }
    var sorted_box_designs = box_designs.sort((a, b) => b.id - a.id);
    return sorted_box_designs.map((t) => ({ value: t.id, label: t.name, name: "boxDesign", obj: t }))
  }

  fetchDrillDesigns = async () => {
    this.getBoxDesigns(this.state.boxType);
  }

  fetchUVDesigns = async () => {
    this.getBoxUVDesigns(this.state.boxType);
  }

  handleSelectDrillDesignChangeSelect = (val) => {
    var curr_selectedProducts = JSON.parse(JSON.stringify((this.state.selectedProducts)));
    var selected_drill_prodcuts = curr_selectedProducts.filter(p => p.is_drill_product === true && !p.is_predrill)

    const extraHoleSku = 'A-99999-CST-DR-H1';

    selected_drill_prodcuts.forEach(a => {
      var selected_drill_prodcut_index = curr_selectedProducts.findIndex(b => b.id === a.id);
      if(selected_drill_prodcut_index > -1){
        if(val === null){
          curr_selectedProducts[selected_drill_prodcut_index].TEMPLATE_SELECT = null;
          // Clear SERVICE_SELECT when no design is selected
          curr_selectedProducts[selected_drill_prodcut_index].SERVICE_SELECT = [];
        }else{
          curr_selectedProducts[selected_drill_prodcut_index].TEMPLATE_SELECT = val.obj;

          // Add extra hole product to SERVICE_SELECT if required_drill_holes > 0
          if (val.obj && val.obj.required_drill_holes > 0) {
            const extraHoleProduct = this.state.drillServiceProducts.find(p => p.sku === extraHoleSku);
            if (extraHoleProduct) {
              const extraHoleWithQty = {
                ...extraHoleProduct,
                qty: val.obj.required_drill_holes,
                is_extra_hole_product: true
              };
              curr_selectedProducts[selected_drill_prodcut_index].SERVICE_SELECT = [extraHoleWithQty];
            } else {
              curr_selectedProducts[selected_drill_prodcut_index].SERVICE_SELECT = [];
            }
          } else {
            curr_selectedProducts[selected_drill_prodcut_index].SERVICE_SELECT = [];
          }
        }
      }
    })

    if(val == null){
      this.setState({
        selectedDrillDesign: {id: "", name : ""},
        selectedProducts: curr_selectedProducts
      })
    }else{
      if (val.value) {
        this.setState({
          selectedDrillDesign: val.obj,
          selectedProducts: curr_selectedProducts
        })
      }
    }
  }

  handleUVPrintChangeSelect = (val, index) => {
    var curr_selectedProducts = JSON.parse(JSON.stringify((this.state.selectedProducts)));
    if(val == null){
      var uv_products = curr_selectedProducts.filter(p =>  p.is_uv_product === true)
      if(uv_products.length > 1){
        uv_products.splice(index, 1);
        var new_curr_selectedProducts = curr_selectedProducts.filter(a => !uv_products.includes(a))
        curr_selectedProducts = new_curr_selectedProducts
      }else{
        var new_curr_selectedProducts = curr_selectedProducts.filter(a => !uv_products.includes(a))
        curr_selectedProducts = new_curr_selectedProducts
      }

      var new_curr_selectedUVPrints = JSON.parse(JSON.stringify(this.state.selectedUVPrints));
      new_curr_selectedUVPrints[index] = {id: null}

      this.setState({
        selectedProducts: curr_selectedProducts,
        selectedUVPrints: new_curr_selectedUVPrints,
      })

    }else{
      var uv_product_index = this.state.uvProducts.findIndex(a => a.id == val.value);
      if(uv_product_index != -1){
        var uv_products = curr_selectedProducts.filter(p =>  p.is_uv_product === true)
        if(uv_products.length > 0 && uv_products.length > index){
          var old_uv_product_id = uv_products[index].id;
          var old_uv_product_index = curr_selectedProducts.findIndex(a => a.id == old_uv_product_id);
          if(old_uv_product_index > -1){
            curr_selectedProducts.splice(old_uv_product_index, 1);
          }
        }
        curr_selectedProducts.push(this.state.uvProducts[uv_product_index])

        var new_curr_selectedUVPrints = JSON.parse(JSON.stringify(this.state.selectedUVPrints));
        new_curr_selectedUVPrints[index] = this.state.uvProducts[uv_product_index]

        this.setState({
          selectedProducts: curr_selectedProducts,
          selectedUVPrints: new_curr_selectedUVPrints,
        })
      }
    }
  }

  handleUVPrintTemplateChangeSelect = (val, index) => {
    var curr_selectedProducts = JSON.parse(JSON.stringify((this.state.selectedProducts)));
    var selected_uv_products = curr_selectedProducts.filter(p =>  p.is_uv_product === true)

    //var curr_selected_uv_products_index = curr_selectedProducts.findIndex(a => a.id == selected_uv_products[index].id);
    var curr_selected_uv_products_index = curr_selectedProducts.length - selected_uv_products.length + index;

    var new_curr_selectedUVPrints = JSON.parse(JSON.stringify((this.state.selectedUVPrints)));

    if(val == null){
      curr_selectedProducts[curr_selected_uv_products_index].TEMPLATE_SELECT = null;
      new_curr_selectedUVPrints[index].TEMPLATE_SELECT = null;
      // Clear the has_gloss, has_white, has_color when template is cleared
      curr_selectedProducts[curr_selected_uv_products_index].has_gloss = false;
      curr_selectedProducts[curr_selected_uv_products_index].has_white = false;
      curr_selectedProducts[curr_selected_uv_products_index].has_color = false;
      new_curr_selectedUVPrints[index].has_gloss = false;
      new_curr_selectedUVPrints[index].has_white = false;
      new_curr_selectedUVPrints[index].has_color = false;
    }else{
      curr_selectedProducts[curr_selected_uv_products_index].TEMPLATE_SELECT = val.obj;
      new_curr_selectedUVPrints[index].TEMPLATE_SELECT = val.obj;
      // Auto-check has_gloss, has_white, has_color based on template's layer support
      const hasGloss = val.obj.gloss_layer === "Yes";
      const hasWhite = val.obj.white_layer === "Yes";
      const hasColor = val.obj.color_layer === "Yes";
      curr_selectedProducts[curr_selected_uv_products_index].has_gloss = hasGloss;
      curr_selectedProducts[curr_selected_uv_products_index].has_white = hasWhite;
      curr_selectedProducts[curr_selected_uv_products_index].has_color = hasColor;
      new_curr_selectedUVPrints[index].has_gloss = hasGloss;
      new_curr_selectedUVPrints[index].has_white = hasWhite;
      new_curr_selectedUVPrints[index].has_color = hasColor;
    }

    this.setState({
      selectedProducts: curr_selectedProducts,
      selectedUVPrints: new_curr_selectedUVPrints
    })
  }

  handleUVPrintLayerCheckboxChange = (e, index, layerType) => {
    // layerType is either 'has_gloss' or 'has_white'
    var new_curr_selectedUVPrints = JSON.parse(JSON.stringify(this.state.selectedUVPrints));
    new_curr_selectedUVPrints[index][layerType] = e.target.checked;

    // Also update selectedProducts to keep them in sync
    var curr_selectedProducts = JSON.parse(JSON.stringify(this.state.selectedProducts));
    var selected_uv_products = curr_selectedProducts.filter(p => p.is_uv_product === true);
    var curr_selected_uv_products_index = curr_selectedProducts.length - selected_uv_products.length + index;

    if (curr_selectedProducts[curr_selected_uv_products_index]) {
      curr_selectedProducts[curr_selected_uv_products_index][layerType] = e.target.checked;
    }

    this.setState({
      selectedUVPrints: new_curr_selectedUVPrints,
      selectedProducts: curr_selectedProducts
    });
  }

  handleUVPrintOptionsCheckboxesChange = (e, type, index, obj) => {
    //test
    var curr_selectedProducts = JSON.parse(JSON.stringify((this.state.selectedProducts)));
    var selected_uv_products = curr_selectedProducts.filter(p =>  p.is_uv_product === true)

    //var curr_selected_uv_products_index = curr_selectedProducts.findIndex(a => a.id == selected_uv_products[index].id);
    var curr_selected_uv_products_index = curr_selectedProducts.length - selected_uv_products.length + index;

    if(!curr_selectedProducts[curr_selected_uv_products_index]["SERVICE_SELECT"]){
      curr_selectedProducts[curr_selected_uv_products_index].SERVICE_SELECT = []
    }
    var curr_SERVICE_SELECT = curr_selectedProducts[curr_selected_uv_products_index].SERVICE_SELECT;

    if(e.target.checked){
      curr_SERVICE_SELECT.push(obj);
      curr_selectedProducts[curr_selected_uv_products_index].SERVICE_SELECT = curr_SERVICE_SELECT;
    }else{
      var curr_obj_index = curr_SERVICE_SELECT.findIndex(a => a.id == obj.id);
      if(curr_obj_index > -1){
        if(curr_SERVICE_SELECT.length > 1){
          curr_SERVICE_SELECT.splice(curr_obj_index, 1);
          curr_selectedProducts[curr_selected_uv_products_index].SERVICE_SELECT = curr_SERVICE_SELECT;
        }else{
          curr_SERVICE_SELECT = [];
          curr_selectedProducts[curr_selected_uv_products_index].SERVICE_SELECT = curr_SERVICE_SELECT;
        }
      }
    }

    this.setState({
      selectedProducts: curr_selectedProducts,
    })
  }

  toggleAlert = () => {
    this.setState({ showAlert: !this.state.showAlert });
  };

  getUVPrintOptionsCheckboxes = (index, product) => {
    var curr_selectedProducts = JSON.parse(JSON.stringify((this.state.selectedProducts)));
    var selected_uv_products = curr_selectedProducts.filter(p =>  p.is_uv_product === true)

    if(selected_uv_products[index] && selected_uv_products[index]["SERVICE_SELECT"]){
      if(selected_uv_products[index].SERVICE_SELECT.length > 0){
        var curr_product_index = selected_uv_products[index].SERVICE_SELECT.findIndex(a => a.id == product.id);
        if(curr_product_index > -1){
          return true;
        }else{
          return false;
        }
      } else {
        return false;
      }
    }else{
      return false;
    }
  }

  getDisabledUVPrintOptionsCheckboxes = (index) => {
    var curr_selectedProducts = JSON.parse(JSON.stringify((this.state.selectedProducts)));
    var selected_uv_products = curr_selectedProducts.filter(p =>  p.is_uv_product === true)

    if(selected_uv_products[index]){
      return false;
    }else{
      return true;
    }
  }

  getFilteredUVServiceProducts = (selectedTemplate) => {
    // Return all UV service products (no longer filtering)
    return this.state.uvServiceProducts;
  }

  isUVServiceProductAvailable = (product, uvPrintObject) => {
    const selectedTemplate = uvPrintObject?.TEMPLATE_SELECT;

    // Check if gloss product is available
    if (product.is_gloss_product) {
      // Template must support gloss AND user must have checked has_gloss
      if (!selectedTemplate || selectedTemplate.gloss_layer !== "Yes") {
        return false;
      }
      if (!uvPrintObject?.has_gloss) {
        return false;
      }
    }
    // Check if white product is available
    if (product.is_white_product) {
      // Template must support white AND user must have checked has_white
      if (!selectedTemplate || selectedTemplate.white_layer !== "Yes") {
        return false;
      }
      if (!uvPrintObject?.has_white) {
        return false;
      }
    }
    // Check if color product is available
    // if (product.is_color_product) {
    //   // Template must support color AND user must have checked has_color
    //   if (!selectedTemplate || selectedTemplate.color_layer !== "Yes") {
    //     return false;
    //   }
    //   if (!uvPrintObject?.has_color) {
    //     return false;
    //   }
    // }
    return true;
  }

  getUVServiceProductUnavailableReason = (product, uvPrintObject) => {
    const selectedTemplate = uvPrintObject?.TEMPLATE_SELECT;

    if (product.is_gloss_product) {
      if (!selectedTemplate || selectedTemplate.gloss_layer !== "Yes") {
        return "This service is not available because the selected UV Template does not support Gloss layer. Upload a UV Template with RDG Gloss Spot Colors to enable this option.";
      }
      if (!uvPrintObject?.has_gloss) {
        return "This service is not available. Check 'My Box Job will have: RDG Gloss Spot Color' above to enable this option.";
      }
    }
    if (product.is_white_product) {
      if (!selectedTemplate || selectedTemplate.white_layer !== "Yes") {
        return "This service is not available because the selected UV Template does not support White layer. Upload a UV Template with RDG White Spot Colors to enable this option.";
      }
      if (!uvPrintObject?.has_white) {
        return "This service is not available. Check 'My Box Job will have: RDG White Spot Color' above to enable this option.";
      }
    }
    if (product.is_color_product) {
      if (!selectedTemplate || selectedTemplate.color_layer !== "Yes") {
        return "This service is not available because the selected UV Template does not support CMYK Color layer. Upload a UV Template with CMYK Color to enable this option.";
      }
      if (!uvPrintObject?.has_color) {
        return "This service is not available. Check 'My Box Job will have: CMYK Color' above to enable this option.";
      }
    }
    return null;
  }

  // Enclosure Service Products handlers
  handleEnclosureServiceProductChange = (e, product) => {
    let selectedEnclosureServiceProducts = [...this.state.selectedEnclosureServiceProducts];
    let selectedProducts = [...this.state.selectedProducts];

    if (e.target.checked) {
      // Add product to selected enclosure service products
      selectedEnclosureServiceProducts.push(product);
      selectedProducts.push(product);
    } else {
      // Remove product from selected enclosure service products
      selectedEnclosureServiceProducts = selectedEnclosureServiceProducts.filter(p => p.id !== product.id);
      selectedProducts = selectedProducts.filter(p => p.id !== product.id);
    }

    this.setState({
      selectedEnclosureServiceProducts,
      selectedProducts
    });
  }

  isEnclosureServiceProductSelected = (product) => {
    return this.state.selectedEnclosureServiceProducts.some(p => p.id === product.id);
  }

  handleEnclosureServiceAttributeChange = (e, product) => {
    let selectedEnclosureServiceProducts = [...this.state.selectedEnclosureServiceProducts];
    let selectedProducts = [...this.state.selectedProducts];

    // Find and update the product in selectedEnclosureServiceProducts
    const serviceIndex = selectedEnclosureServiceProducts.findIndex(p => p.id === product.id);
    if (serviceIndex !== -1) {
      selectedEnclosureServiceProducts[serviceIndex] = {
        ...selectedEnclosureServiceProducts[serviceIndex],
        attribute_value: e.target.value
      };
    }

    // Also update in selectedProducts
    const productIndex = selectedProducts.findIndex(p => p.id === product.id);
    if (productIndex !== -1) {
      selectedProducts[productIndex] = {
        ...selectedProducts[productIndex],
        attribute_value: e.target.value
      };
    }

    this.setState({
      selectedEnclosureServiceProducts,
      selectedProducts
    });
  }

  handleEnclosureServiceAttributeSelectChange = (val, product) => {
    let selectedEnclosureServiceProducts = [...this.state.selectedEnclosureServiceProducts];
    let selectedProducts = [...this.state.selectedProducts];
    const attributeValue = val ? val.value : '';

    // Find and update the product in selectedEnclosureServiceProducts
    const serviceIndex = selectedEnclosureServiceProducts.findIndex(p => p.id === product.id);
    if (serviceIndex !== -1) {
      selectedEnclosureServiceProducts[serviceIndex] = {
        ...selectedEnclosureServiceProducts[serviceIndex],
        attribute_value: attributeValue
      };
    }

    // Also update in selectedProducts
    const productIndex = selectedProducts.findIndex(p => p.id === product.id);
    if (productIndex !== -1) {
      selectedProducts[productIndex] = {
        ...selectedProducts[productIndex],
        attribute_value: attributeValue
      };
    }

    this.setState({
      selectedEnclosureServiceProducts,
      selectedProducts
    });
  }

  getEnclosureServiceAttributeValue = (product) => {
    const selectedProduct = this.state.selectedEnclosureServiceProducts.find(p => p.id === product.id);
    return selectedProduct ? selectedProduct.attribute_value || '' : '';
  }

  getPowderColors = (box_type) => {
    let colors = [];

    if (box_type) {
      this.setState({
        loading: true
      }, async () => {
        console.log('fetching colors for box_type', box_type);
        var result =  await this.submitGetRequest(process.env.REACT_APP_API_URL + '/api/v4/products/powder_colors?enclosure_type=' + box_type);

        if(result["errors"]){
          console.log('result error: ',result["errors"]);
          let errors = "";
          if (typeof result["errors"] === 'string') {
            errors = result["errors"];
          } else {
            errors = Object.keys(result["errors"]).map(key => {
              let human_key = humanize(key);
              return  human_key + " " + result["errors"][key];
            })
          }
          this.setState({ alertMsg: errors, showAlert: true, showSuccess: false, loading: false})
        }else{
          colors = result;
          this.setState({ colors: colors });
          this.getBoxDesigns(box_type);
          this.getBoxUVDesigns(box_type);
        }
      })
    }
  }

  getPowderColorsAndSkus = (box_type) => {
    if (box_type) {
      this.setState({
        loading: true
      }, async () => {
        try {
          console.log('fetching colors for box_type', box_type);
          var result =  await this.submitGetRequest(process.env.REACT_APP_API_URL + '/api/v4/products/powder_colors_and_skus?enclosure_type=' + box_type);

          if(result && result["errors"]){
            console.log('result error: ',result["errors"]);
            let errors = "";
            if (typeof result["errors"] === 'string') {
              errors = result["errors"];
            } else {
              errors = Object.keys(result["errors"]).map(key => {
                let human_key = humanize(key);
                return  human_key + " " + result["errors"][key];
              }).join(", ")
            }
            this.setState({ colors: [], alertMsg: errors, showAlert: true, showSuccess: false, loading: false})
          }else if(!Array.isArray(result)){
            // submitGetRequest returns the error message string when the request fails
            console.log('unexpected powder_colors_and_skus response: ', result);
            this.setState({
              colors: [],
              alertMsg: typeof result === 'string' && result !== "" ? result : "Unable to load enclosure colors, please try again.",
              showAlert: true,
              showSuccess: false,
              loading: false
            })
          }else{
            this.setState({ colors: result });
            this.getBoxDesigns(box_type);
            this.getBoxUVDesigns(box_type);
          }
        } catch (error) {
          console.log('error', error);
          this.setState({ colors: [], alertMsg: error.message, showAlert: true, showSuccess: false, loading: false })
        }
      })
    }
  }

  getBoxDesigns = (box_type) => {
    let box_designs = [];

    this.setState({
      loading: true
    }, async () => {
      var result =  await this.submitGetRequest(process.env.REACT_APP_API_URL + '/api/v4/box_designs?enclosure_type=' + box_type);

      if(result["errors"]){
        console.log('result error: ',result["errors"]);
        let errors = "";
        if (typeof result["errors"] === 'string') {
          errors = result["errors"];
        } else {
          errors = Object.keys(result["errors"]).map(key => {
            let human_key = humanize(key);
            return  human_key + " " + result["errors"][key];
          })
        }
        this.setState({ alertMsg: errors, showAlert: true, showSuccess: false, loading: false})
      }else{
        box_designs = result["box_designs"] ? result.box_designs : [];
        this.setState({ box_designs: box_designs, loading: false });
      }
    })
  }

  getBoxUVDesigns = (box_type) => {
    let box_uv_designs = [];

    this.setState({
      loading: true
    }, async () => {
      var result =  await this.submitGetRequest(process.env.REACT_APP_API_URL + '/api/v4/box_uv_designs?enclosure_type=' + box_type);

      if(result["errors"]){
        console.log('result error: ',result["errors"]);
        let errors = "";
        if (typeof result["errors"] === 'string') {
          errors = result["errors"];
        } else {
          errors = Object.keys(result["errors"]).map(key => {
            let human_key = humanize(key);
            return  human_key + " " + result["errors"][key];
          })
        }
        this.setState({ alertMsg: errors, showAlert: true, showSuccess: false, loading: false})
      }else{
        box_uv_designs = result["box_uv_designs"] ? result.box_uv_designs : [];

        const hydratedSelectedUVPrints = (this.state.selectedUVPrints || []).map(uvPrint => {
          if (uvPrint && uvPrint.TEMPLATE_SELECT && uvPrint.TEMPLATE_SELECT.id) {
            const full = box_uv_designs.find(d => d.id === uvPrint.TEMPLATE_SELECT.id);
            if (full) {
              return {
                ...uvPrint,
                TEMPLATE_SELECT: {
                  ...full,
                  ...uvPrint.TEMPLATE_SELECT,
                  document_url: uvPrint.TEMPLATE_SELECT.document_url || full.document_url
                }
              };
            }
          }
          return uvPrint;
        });

        this.setState({ box_uv_designs: box_uv_designs, selectedUVPrints: hydratedSelectedUVPrints, loading: false });
      }
    })
  }

  fetchAvailableProducts = async (box_type, powder_color) => {
    let products = [];
    if (box_type && powder_color) {
      this.setState({
        loading: true
      }, async ()=> {
        try {
          console.log('fetching products for box_type', box_type, 'powder_color', powder_color);
          const result = await this.submitGetRequest(`${process.env.REACT_APP_API_URL}/api/v4/products?enclosure_type=${box_type}&powder_color=${powder_color}`);

          if (result.errors) {
            console.log('result error: ', result.errors);
            let errors = "";
            if (typeof result.errors === 'string') {
              errors = result.errors;
            } else {
              errors = Object.keys(result.errors).map(key => {
                let human_key = humanize(key);
                return human_key + " " + result.errors[key];
              }).join(", ");
            }
            this.setState({ alertMsg: errors, showAlert: true, showSuccess: false, loading: false });
          } else {
            products = result;

            let enclosureProducts = products.filter(p => p.enclosure_type === box_type && p.powder_color && p.powder_color !== '');
            let drillProducts = products.filter(p => p.is_drill_product === true && !p.is_predrill);
            let uvProducts = products.filter(p => p.is_uv_product === true);
            let serviceProducts = products.filter(p => p.is_service_product === true);
            let enclosureServiceProducts = products.filter(p => p.is_enclosure_service_product === true);
            let uvServiceProducts = products.filter(p => p.is_uv_service_product === true);
            let drillServiceProducts = products.filter(p => p.is_drill_service_product === true);
            // console.log('drillProducts', drillProducts);
            // console.log('uvProducts', uvProducts);
            // console.log('drillServiceProducts', drillServiceProducts);
            // console.log('uvServiceProducts', uvServiceProducts);
            // console.log('enclosureProducts', enclosureProducts);
            // console.log('enclosureServiceProducts', enclosureServiceProducts);

            this.setState({ enclosureProducts, drillProducts, uvProducts, serviceProducts, uvServiceProducts, enclosureServiceProducts, drillServiceProducts, loading: false, collapse: false }, () => {
              this.handleEnclosureChange(null);
            });
          }
        } catch (error) {
          console.log('error', error);
          this.setState({ showAlert: true, showSuccess: false, alertMsg: error.message });
        }
      });
    }
  }

  orderBoxJob = (e) => {
    this.setState({ readyToSave: true, orderBoxJob: true });

    // if (this.state.configurationName !== "") {
      this.handleSubmit(e, true);
    // } else {
    //   this.setState({ alertMsg: "Please enter a configuration name", showAlert: true });
    // }
  }

  handleSubmit = (e, orderBoxJob) => {
    e.preventDefault();

    /*
    box_configuration": {
      "name": "My Job  ",
      "enclosure_type": "1590BB",
      "powder_color": "MATTE BLACK",
      "product_id": "5850",
      "box_configuration_items_attributes": [
      {
        "product_id": "6202",
        "product_type": "drill",
        "design_id": 1
      },
      {
        "product_id": "6509",
        "product_type": "uv",
        "design_id": 2,
        "box_configuration_item_services_attributes": [
          {
            "product_id": "6980",
            "service_type": "gloss"
          }
        ]
      }]
    }
    */
    var cur_selected_products = JSON.parse(JSON.stringify(this.state.selectedProducts));
    let cur_selected_enclosure_products = cur_selected_products.filter(p => p.enclosure_type === this.state.boxType && p.powder_color && p.powder_color !== '');
    let cur_selected_drill_products = cur_selected_products.filter(p => p.is_drill_product === true && !p.is_predrill);
    let cur_selected_uv_products = cur_selected_products.filter(p => p.is_uv_product === true);
    let cur_selected_enclosure_service_products = JSON.parse(JSON.stringify(this.state.selectedEnclosureServiceProducts));

    let body = {
      "name": this.state.configurationName,
      "enclosure_type": cur_selected_enclosure_products[0].enclosure_type,
      "powder_color": cur_selected_enclosure_products[0].powder_color,
      "product_id": cur_selected_enclosure_products[0].id,
    }

    if(cur_selected_drill_products.length > 0 || cur_selected_uv_products.length > 0 || cur_selected_enclosure_service_products.length > 0){
      body.box_configuration_items_attributes = []
    }

    // Add enclosure product as box_configuration_item with enclosure services as item_services
    if(cur_selected_enclosure_service_products.length > 0){
      var enclosure = {
        "product_id": cur_selected_enclosure_products[0].id,
        "product_type": "enclosure",
        "box_configuration_item_services_attributes": []
      }
      cur_selected_enclosure_service_products.forEach(service => {
        const serviceAttributes = {
          "product_id": service.id,
          "service_type": service.service_type || "enclosure_service"
        };
        // Include attribute_value if present (for lid_Color service type)
        if (service.attribute_value) {
          serviceAttributes.attribute_value = service.attribute_value;
        }
        enclosure.box_configuration_item_services_attributes.push(serviceAttributes);
      })
      body.box_configuration_items_attributes.push(enclosure)
    }

    if(cur_selected_drill_products.length > 0){
      cur_selected_drill_products.forEach(a => {
        if(a.TEMPLATE_SELECT != null){
          var drill = {
            "product_id": a.id,
            "product_type": a.service_type,
            "design_id": a.TEMPLATE_SELECT.id,
            "box_configuration_item_services_attributes": []
          }
          // Add drill services (like extra holes) if present
          if(a.SERVICE_SELECT !== undefined && a.SERVICE_SELECT.length > 0){
            a.SERVICE_SELECT.forEach(b => {
              drill.box_configuration_item_services_attributes.push({
                "product_id": b.id,
                "service_type": b.service_type || "drill_service",
                "quantity": b.qty || 1
              })
            })
          }
          body.box_configuration_items_attributes.push(drill)
        }
      })
    }

    if(cur_selected_uv_products.length > 0){
      cur_selected_uv_products.forEach(a => {
        if(a.TEMPLATE_SELECT != null && a.TEMPLATE_SELECT !== undefined){
          var uv = {
            "product_id": a.id,
            "product_type": a.service_type,
            "design_id": a.TEMPLATE_SELECT.id,
            "has_gloss": a.has_gloss || false,
            "has_white": a.has_white || false,
            "has_color": a.has_color || false,
            "box_configuration_item_services_attributes": []
          }
          if(a.SERVICE_SELECT !== undefined && a.SERVICE_SELECT.length > 0){
            a.SERVICE_SELECT.forEach(b => {
              uv.box_configuration_item_services_attributes.push({
                "product_id": b.id,
                "service_type": b.service_type
              })
            })
          }

          body.box_configuration_items_attributes.push(uv)
        }
      })
    }

    this.setState({
      loading: true
    }, async ()=> {
      try {
        let result = null;
        if (this.state.boxConfigurationId !== "") {
          result = await this.submitPostRequest(`${process.env.REACT_APP_API_URL}/api/v4/box_configurations/${this.state.boxConfigurationId}`, body, true);
        } else {
          result = await this.submitPostRequest(`${process.env.REACT_APP_API_URL}/api/v4/box_configurations`, body);
        }
        if (result.errors) {
          console.log('result error: ', result.errors);
          let errors = "";
          if (typeof result.errors === 'string') {
            errors = result.errors;
          } else {
            errors = Object.keys(result.errors).map(key => {
              let human_key = humanize(key);
              return human_key + " " + result.errors[key];
            }).join(", ");
          }
          this.setState({ alertMsg: errors, showAlert: true, showSuccess: false, loading: false });
        } else {
          // console.log('result', result);

          let box_configuration = result.box_configuration;
          // console.log('box_configuration', box_configuration);

          if(this.state.orderBoxJob){
            this.setState({ loading: true, showAlert: false, orderBoxJob: false, box_configuration: box_configuration, boxConfigurationId: box_configuration.id }, () => {
              //console.log(this.state);
              //this.setState({ openOrderModal: true })
              this.getValidation(1);
            });
          }else{
            this.setState({
              loading: false,
              showAlert: false,
              showSuccess: true,
              successMsg: "Box Job Template saved successfully! Return to the Box Job Templates page to create an order.",
              orderBoxJob: false,
              openOrderModal: false,
              box_configuration: null,
              boxConfigurationId: box_configuration.id
            });
          }

          if (box_configuration) {
            const history = createBrowserHistory();
            let params = '?id=' + box_configuration.id;
            if (orderBoxJob === true) {
              params += '&orderBoxJob=true';
            }
            history.push('/box-configurations' + params);
          }
        }
      } catch (error) {
        console.log('error', error);
        this.setState({ showAlert: true, showSuccess: false, alertMsg: error.message, loading: false, orderBoxJob: false });
      }
    });
  }

  submitGetRequest = async (url) => {
    let token = JSON.parse(localStorage.getItem("token"));
    var result =  await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': "Bearer " + token,
        'Content-Type': 'application/json'
      },
    })
    .then(response => response.json())
    .then(data => {
      // console.log('data', data);
      return data;
    })
    .catch((error) => {
      console.log('error', error);
      this.setState({ showAlert: true, showSuccess: false, alertMsg: error.message });
      return error.message;
    });
    return result;
  }

  submitPostRequest = async (url, body, isPut) => {
    let token = JSON.parse(localStorage.getItem("token"));
    var result =  await fetch(url, {
      method: isPut ? 'PUT' : 'POST',
      headers: {
        'Authorization': "Bearer " + token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
    .then(response => response.json())
    .then(data => {
      console.log('data', data);
      return data;
    })
    .catch((error) => {
      console.log('error', error);
      this.setState({ showAlert: true, showSuccess: false, alertMsg: error.message });
      return error.message;
    });
    return result;
  }

  getSelectedDrillProduct = (product_id) => {
    var drillProduct = this.state.drillProducts.find(a => a.id == product_id);
    var selectedProduct = this.state.selectedProducts.find(a => a.id == product_id);
    return !!(selectedProduct && drillProduct);
  }

  addUVSideCounts = () => {
    var new_curr_selectedUVPrints = JSON.parse(JSON.stringify(this.state.selectedUVPrints));
    new_curr_selectedUVPrints.push({id: null})
    this.setState({
      uvSidesCount: this.state.uvSidesCount + 1,
      selectedUVPrints: new_curr_selectedUVPrints
    }, () => {
      var box_uv_designs = this.getUVOptions();
      if(box_uv_designs.length === 1){
        this.handleUVPrintChangeSelect({value: box_uv_designs[0].value, label: box_uv_designs[0].box_side, name: "uvPrint" }, (this.state.uvSidesCount - 1));
      }
    })
  }

  minusUVSideCounts = (index) => {
    var new_curr_selectedUVPrints = JSON.parse(JSON.stringify(this.state.selectedUVPrints));
    var curr_selectedProducts = JSON.parse(JSON.stringify((this.state.selectedProducts)));

    var selected_uv_products = curr_selectedProducts.filter(p =>  p.is_uv_product === true)
    var old_uv_product_index = curr_selectedProducts.length - selected_uv_products.length + index;

    curr_selectedProducts.splice(old_uv_product_index, 1);

    new_curr_selectedUVPrints.splice(index, 1);
    this.setState({
      uvSidesCount: this.state.uvSidesCount - 1,
      selectedProducts: curr_selectedProducts,
      selectedUVPrints: new_curr_selectedUVPrints,
    })
  }

  getUVSelectedValue = (index) => {
    var curr_selectedUVPrints = JSON.parse(JSON.stringify(this.state.selectedUVPrints));
    var uv_product_id = curr_selectedUVPrints[index].id;

    if(uv_product_id == null){
      return {value: "", label: ""}
    }else{
      var uv_product_index = this.state.uvProducts.findIndex(a => a.id == uv_product_id)
      if(uv_product_index > -1){
        return {value: this.state.uvProducts[uv_product_index].id, label: this.state.uvProducts[uv_product_index].box_side}
      }
    }
  }

  getBoxSide = (value) => {
    var box_side = this.state.boxSides.find(a => a.key === value);
    return box_side;
  }

  getBoxSideLabel = (value) => {
    var box_side = this.getBoxSide(value);
    return box_side ? box_side.label : value;
  }

  getBoxSideKey = (value) => {
    var box_side = this.getBoxSide(value);
    return box_side ? box_side.key : value;
  }

  getUVOptions = () => {
    // Get the IDs of already selected UV products
    const selectedUVProductIds = this.state.selectedUVPrints
      .filter(uv => uv && uv.id)
      .map(uv => uv.id);

    // Filter out UV products that are already selected
    return this.state.uvProducts
      .filter(t => !selectedUVProductIds.includes(t.id))
      .map((t) => {
        return { value: t.id, label: this.getBoxSideLabel(t.box_side), name: "uvPrint", key: this.getBoxSideKey(t.box_side) };
      });
  }

  getUVSideBoxDesigns = (index) => {
    var curr_selectedUVPrints = JSON.parse(JSON.stringify(this.state.selectedUVPrints));
    var uv_product_id = curr_selectedUVPrints[index].id;

    if(uv_product_id == null || uv_product_id == ""){
      return []
    }else{
      var uv_product_index = this.state.uvProducts.findIndex(a => a.id == uv_product_id)
      var selected_uv_box_side = this.state.uvProducts[uv_product_index].box_side
      var box_uv_designs = this.state.box_uv_designs.filter(a => a.box_side.includes(selected_uv_box_side))
      return box_uv_designs.map((t) => ({ value: t.id, label: t.name, name: "boxUVDesigns", obj: t }));
    }
  }

  getValidation = async (qty, order_number) => {
    // let token = JSON.parse(localStorage.getItem("token"));
    // this.os.validateBoxConfiguration(token, this.state.box_configuration.id, qty, order_number).then((result) => {
    //   if (result.meets_requirements === false) {
    //     var alertMsg = result.required_products
    //       .filter((product) => product.required_qty > 0 && product.is_placeholder !== true)
    //       .map((product) => { return `${product.sku}, ${product.required_qty}` })

    //       if (alertMsg.length > 0) {
    //         alertMsg.unshift("Products Needed");
    //       }
    //       this.setState({ loading: false, showWarning: true, warningMsg: alertMsg.join('\n'), openOrderModal: true });
    //   } else {
    //       this.setState({ showWarning: false, warningMsg: "", openOrderModal: true });
    //   }
    // }).catch((error) => {
    //   console.log('error', error);
    //   this.setState({
    //     loading: false,
    //     showAlert: true,
    //     alertMsg: "Error validating box_job " + error
    //   })
    // })
    this.setState({ loading: false, showWarning: false, warningMsg: "", openOrderModal: true });

  }

  toggleOrderModal = () => {
    let showSuccess = this.state.showSuccess;
    if (this.state.openOrderModal && showSuccess) {
      showSuccess = false;
    }
    this.setState({openOrderModal: !this.state.openOrderModal, showSuccess: showSuccess})
  }

  checkQty = async (e) => {
    this.setState({ qty: e.target.value });
    // CAll API box_configurations/id/validate to check if the qty is valid
    // if (e.target.value > 0) {
    //     this.getValidation(e.target.value);
    // }
  }

  reserveBoxConfiguration = async () => {
    // Directly reserve - confirmation is now handled by checkbox in the modal
    let token = JSON.parse(localStorage.getItem("token"));
    this.os.reserveBoxConfiguration(token, this.state.box_configuration.id, this.state.qty).then((result) => {
      console.log('reserve result', result);
      if (result.error) {
        this.setState({
          loading: false,
          showAlert: true,
          alertMsg: "Error reserving box job. " + result.error
        })
      } else {
        this.setState({
          loading: false,
          showAlert: false,
          alertMsg: "",
          readyToOrder: false,
          showSuccess: true,
          formSubmitted: true,
          successMsg: result.message || "This Box Job Template is reserved and will be created automatically when your order is placed and box job is processed."
        })
      }
    }).catch((error) => {
      this.setState({
        loading: false,
        showAlert: true,
        alertMsg: "Error reserving box job. " + error.message
      })
    })
  }

  reserveBoxConfigurationWithOrder = async (orderNumber) => {
    // Reserve with a specific order number
    let token = JSON.parse(localStorage.getItem("token"));
    this.os.reserveBoxConfiguration(token, this.state.box_configuration.id, this.state.qty, orderNumber).then((result) => {
      console.log('reserve with order result', result);
      if (result.error) {
        this.setState({
          loading: false,
          showAlert: true,
          alertMsg: "Error reserving box job. " + result.error
        })
      } else {
        this.setState({
          loading: false,
          showAlert: false,
          alertMsg: "",
          readyToOrder: false,
          showSuccess: true,
          formSubmitted: true,
          successMsg: result.message || `Box Job reserved for Order #${orderNumber}. It will be created automatically when the order is processed.`
        })
      }
    }).catch((error) => {
      this.setState({
        loading: false,
        showAlert: true,
        alertMsg: "Error reserving box job. " + error.message
      })
    })
  }

  render() {
      return (
        <Container fluid className="m-auto px-5 pb-4">
          <ToastContainer
              position="bottom-center"
              autoClose={5000}
              hideProgressBar
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss={false}
              draggable={false}
              pauseOnHover={false}
          />

          {this.state.box_configuration != null &&
            <QuickOrderModal
              isOpen={this.state.openOrderModal}
              toggle={this.toggleOrderModal}
              boxConfiguration={this.state.box_configuration}
              qty={this.state.qty}
              onQtyChange={this.checkQty}
              separateProducts={this.state.separateProducts}
              onSeparateProductsChange={() => this.setState({separateProducts: !this.state.separateProducts})}
              showAlert={this.state.showAlert}
              alertMsg={this.state.alertMsg}
              showSuccess={this.state.showSuccess}
              successMsg={this.state.successMsg}
              showWarning={this.state.showWarning}
              warningMsg={this.state.warningMsg}
              formSubmitted={this.state.formSubmitted}
              onReserve={this.reserveBoxConfiguration}
              availableOrders={this.state.box_configuration.available_orders?.filter(order => order.meets_requirements) || []}
              onReserveWithOrder={this.reserveBoxConfigurationWithOrder}
              storeUrl={this.state.storeUrl}
              // requiredDrillHoles={this.state.box_configuration.required_drill_holes || 0}
            />
          }

          { this.state.loading && (
              <div className="loading style-2">
                  <div className="loading-wheel"></div>
                  <h3 className="loading-message">THIS MIGHT TAKE A FEW MINUTES. PLEASE WAIT...</h3>
              </div>
          )}

          {!this.state.success && (
            <form action="" className="edit-configuration" onSubmit={this.handleSubmit}>
              <Row>
                <Col className="col" md={7}>

                  <h2 className="row p-2 bg-inverse mb-1">
                    <Link to="/my-box-configurations" className="btn btn-outline-secondary btn-sm py-2 px-3 mr-4 float-left " title="Back to My Box Templates">
                     <FontAwesomeIcon icon={faArrowLeft} className="mr-2" /> Back
                    </Link>
                    {this.state.boxConfigurationId ? <span>Edit </span> : <span>Create a </span>}&nbsp;Box Job Template</h2>
                  <h5 className="row p-2 bg-secondary text-white mb-0">
                    1. Choose your Enclosure<span style={{color: "red"}}>*</span>
                    <FontAwesomeIcon
                      icon={faInfoCircle}
                      id="enclosureInfoTooltip"
                      className="ml-2"
                      style={{ cursor: 'pointer', fontSize: '0.9rem' }}
                    />
                    <UncontrolledTooltip
                      placement="right"
                      target="enclosureInfoTooltip"
                      style={{ maxWidth: '400px', textAlign: 'left' }}
                    >
                      <div style={{ textAlign: 'left' }}>
                        <strong>Tayda Electronics Enclosures</strong>
                        <p style={{ marginTop: '8px', marginBottom: '8px' }}>
                          Choose from a wide variety of aluminum enclosures including 125B, 1590A, 1590B, 1590BB, 1590DD, 1590XX and more!
                        </p>
                        <p style={{ marginBottom: '8px' }}>
                          Available in 20+ powder coat colors to match your project's style.
                        </p>
                        <p style={{ marginBottom: '0' }}>
                          Perfect for guitar pedals, DIY electronics, synthesizers, and custom projects. Add custom drilling and UV printing to create professional-quality enclosures.
                        </p>
                      </div>
                    </UncontrolledTooltip>
                  </h5>
                  <Row className="pb-3" style={{border: "1px solid hsl(0,0%,80%)"}}>
                    <Col md="12">
                      <FormGroup row>
                        <Col className="col" md={12}>
                          <label className="col-form-label">Select Enclosure Type</label>
                          <Select
                            key="boxType"
                            name="boxType"
                            isClearable={true}
                            value={{ value: this.state.boxType, label: this.state.boxType}}
                            onChange={this.handleBoxTypeChangeSelect}
                            options={this.state.boxTypes.map((t) => ({ value: t, label: t, name: "boxType" }))}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Col className="col" md={12}>
                          <label className="col-form-label">Select Enclosure Color</label>
                          <Select
                            key="powderColor"
                            name="powderColor"
                            isClearable={true}
                            value={{ value: this.state.powderColor, label: this.getColorLabel(this.state.powderColor)}}
                            onChange={this.handlePowderColorChangeSelect}
                            options={this.getColorOptions().map((o) => ({ ...o, name: "powderColor" }))}
                            isDisabled={this.getColorOptions().length > 0 ? false : true}
                          />
                          <Input type="hidden" name="productId" key="productId" value={this.state.productId}  />
                        </Col>
                      </FormGroup>
                      {/* <Row className="py-4">
                        <Col md="auto" className="d-flex align-items-center">
                          Are you using Predrilled Enclosures?
                        </Col>
                        <Col>
                          <Switch onChange={this.handleUsePredrilledEnclosureChange} checked={this.state.usePredrilledEnclosure}
                          />
                        </Col>
                      </Row> */}
                      <FormGroup row>
                        <Col md={12} className="col">
                          <label className="col-form-label">Select Enclosure Product</label>
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        {this.state.selectedEnclosureProduct.id != "" &&
                          <Col md={{size: 2, offset: 1}} className="col d-flex align-items-center">
                            <img src={this.state.selectedEnclosureProduct.img} className="mx-1 w-100" style={{maxWidth: "80px"}} alt={this.state.selectedEnclosureProduct.name} />
                          </Col>
                        }
                        <Col md={8} className="col d-flex align-items-center">
                          <Select
                            className="w-100"
                            key="enclosureProduct"
                            name="enclosureProduct"
                            isClearable={true}
                            value={{ value: this.state.selectedEnclosureProduct.id, label: this.state.selectedEnclosureProduct.name}}
                            onChange={this.handleEnclosureChange}
                            options={this.getEnclosureProduct()}
                            isDisabled={this.state.enclosureProducts.length > 0 ? false : true}
                          />
                        </Col>
                      </FormGroup>
                      {this.state.selectedEnclosureProduct.id !== "" && this.state.enclosureServiceProducts.length > 0 && (
                        <div className="mt-3 p-3" style={{border: "1px solid hsl(0,0%,80%)", borderRadius: "4px", backgroundColor: "#f8f9fa"}}>
                          <h6 className="mb-3"><b>Additional Enclosure Options</b></h6>
                          {this.state.enclosureServiceProducts.map((product, index) => (
                            <FormGroup check key={"enclosureServiceProduct-" + index} className="mb-2">
                              <Label check className="d-flex align-items-center">
                                <Input
                                  type="checkbox"
                                  id={"enclosureService-" + product.id}
                                  checked={this.isEnclosureServiceProductSelected(product)}
                                  onChange={(e) => this.handleEnclosureServiceProductChange(e, product)}
                                />
                                <span className="ml-2">{product.name}</span>
                                {product.snippet && (
                                  <>
                                    <FontAwesomeIcon
                                      id={"enclosureServiceSnippet-" + product.id}
                                      className="fa-sm ml-1 text-info"
                                      icon={faInfoCircle}
                                      style={{cursor: 'pointer'}}
                                    />
                                    <UncontrolledTooltip placement="right" target={"enclosureServiceSnippet-" + product.id}>
                                      {product.snippet}
                                    </UncontrolledTooltip>
                                  </>
                                )}
                              </Label>
                              {product.service_type === 'lid_color' && this.isEnclosureServiceProductSelected(product) && (
                                <div className="mt-2 ml-4">
                                  <Label for={"enclosureServiceAttribute-" + product.id}>
                                    Select Lid Color:
                                  </Label>
                                  <Select
                                    id={"enclosureServiceAttribute-" + product.id}
                                    name={"attribute_value"}
                                    isClearable={true}
                                    value={this.getEnclosureServiceAttributeValue(product) ? { value: this.getEnclosureServiceAttributeValue(product), label: this.getColorLabel(this.getEnclosureServiceAttributeValue(product)) } : null}
                                    onChange={(val) => this.handleEnclosureServiceAttributeSelectChange(val, product)}
                                    options={this.getColorOptions().filter((o) => String(o.value).trim().toUpperCase() !== String(this.state.powderColor).trim().toUpperCase())}
                                    placeholder="Select lid color..."
                                  />
                                </div>
                              )}
                            </FormGroup>
                          ))}
                        </div>
                      )}
                    </Col>
                  </Row>
                  {this.state.selectedEnclosureProduct.id !== "" && (this.state.drillProducts.length > 0 || this.state.uvProducts.length > 0) &&
                  <>
                    <h5 className="row p-2 bg-secondary text-white mb-0">
                      2. Choose your Services
                      <FontAwesomeIcon
                        icon={faInfoCircle}
                        id="servicesInfoTooltip"
                        className="ml-2"
                        style={{ cursor: 'pointer', fontSize: '0.9rem' }}
                      />
                      <UncontrolledTooltip
                        placement="right"
                        target="servicesInfoTooltip"
                        style={{ maxWidth: '400px', textAlign: 'left' }}
                      >
                        <div style={{ textAlign: 'left' }}>
                          <strong>Custom Enclosure Services</strong>
                          <p style={{ marginTop: '8px', marginBottom: '8px' }}>
                            <strong>Drill Service:</strong> Add precision-drilled holes for knobs, switches, jacks, LEDs, and more. Design your own drill template or use existing ones.
                          </p>
                          <p style={{ marginBottom: '8px' }}>
                            <strong>UV Print Service:</strong> Add stunning full-color UV prints to your enclosure. Supports white ink for vibrant colors on dark enclosures, and gloss finish for a professional look.
                          </p>
                          <p style={{ marginBottom: '0' }}>
                            Customize each side of your enclosure independently - drill and print on top, sides, and even lids!
                          </p>
                        </div>
                      </UncontrolledTooltip>
                    </h5>
                    {!this.state.usePredrilledEnclosure &&
                      <Row className="px-2 py-3" md={12} style={{border: "1px solid hsl(0,0%,80%)"}}>
                        <Col className="p-0">
                        {this.state.drillProducts.length > 0 &&
                          <Container className="px-1">
                            <Row>
                              <Col className="d-flex align-items-center">
                                <h5 className='mb-0'>Add Drill Services</h5>
                              </Col>
                              <Col md="auto">
                                <Switch onChange={this.handleAddDrillServicesChange} checked={this.state.addDrillServices} />
                              </Col>
                            </Row>
                          </Container>
                        }
                        {this.state.addDrillServices &&
                          <Container className="px-1">
                            <hr />
                            <h6><b>Choose Custom Drill Services</b></h6>
                            {this.state.drillProducts.map((product, index) => (
                              <FormGroup check key={"drillProduct"+index}>
                                <Container>
                                  <Row>
                                    <Col md={12} className="col d-flex align-items-center">
                                      <Input
                                        type="checkbox"
                                        id={"addDrillServices-" + product.id}
                                        name={"addDrillServices-" + product.id}
                                        value={product.id}
                                        checked={this.getSelectedDrillProduct(product.id)}
                                        onChange={e => this.handleAddDrillServicesCheckboxesChange(e, product.id)}
                                      />
                                      { product.small_image_url &&
                                        <img src={product.small_image_url} className='m-2' style={{width: "50px"}} alt={product.name} />
                                      }
                                      <Label check for={"addDrillServices-" + product.id} >
                                        {product.name}
                                        {product.snippet && (
                                          <>
                                            <FontAwesomeIcon
                                              id={"drillSnippet-" + product.id}
                                              className="fa-sm ml-1 text-info"
                                              icon={faInfoCircle}
                                              style={{cursor: 'pointer'}}
                                            />
                                            <UncontrolledTooltip placement="right" target={"drillSnippet-" + product.id}>
                                              {product.snippet}
                                            </UncontrolledTooltip>
                                          </>
                                        )}
                                      </Label>
                                    </Col>
                                  </Row>
                                </Container>
                              </FormGroup>
                            ))}
                          </Container>
                        }
                        {this.state.addDrillServices &&
                          <Container className="px-1">
                            <hr />
                            <FormGroup row>
                              <Col className="col" md={12}>
                                <label className="col-form-label"><h6><b>Select Drill Template</b></h6></label>
                                <FontAwesomeIcon className="fa-lg m-2 float-right" icon={faSync} color="#41464b" onClick={this.fetchDrillDesigns} title="Refresh Drill Template Designs" />
                                <a key="addDrillDesign" className="btn btn-sm btn-outline-primary float-right" href="/box-designs/new" target="_blank" title="Add New Drill Template Design">+ New Drill Template</a>
                                <Select
                                  key="boxDesigns"
                                  name="boxDesigns"
                                  isClearable={true}
                                  value={{ value: this.state.selectedDrillDesign.id, label: this.state.selectedDrillDesign.name}}
                                  onChange={this.handleSelectDrillDesignChangeSelect}
                                  options={this.getDrillDesign()}
                                />
                                {this.state.selectedDrillDesign && this.state.selectedDrillDesign.required_drill_holes > 0 && (
                                  <div className="mt-2 p-2" style={{backgroundColor: '#fff3cd', borderRadius: '4px', border: '1px solid #ffc107'}}>
                                    <strong>Extra Drill Holes Required:</strong> {this.state.selectedDrillDesign.required_drill_holes}
                                    <div className="text-muted" style={{fontSize: '0.85rem'}}>
                                      The Extra Hole product (A-99999-CST-DR-H1) will be added to your order.
                                    </div>
                                  </div>
                                )}
                              </Col>
                            </FormGroup>
                          </Container>
                        }
                        </Col>
                      </Row>
                    }

                    <Row className="px-2 py-3" md={12} style={{borderTop: !this.state.usePredrilledEnclosure ? "5px solid hsl(0,0%,80%)" : "1px solid hsl(0,0%,80%)", borderLeft: "1px solid hsl(0,0%,80%)", borderRight: "1px solid hsl(0,0%,80%)", borderBottom: "1px solid hsl(0,0%,80%)"}}>
                      <Col className="p-0">
                        {this.state.uvProducts.length > 0 &&
                          <Container className="px-1">
                            <Row>
                              <Col className="d-flex align-items-center">
                                <h5 className='mb-0'>Add UV Printing Service</h5>
                              </Col>
                              <Col md="auto">
                                <Switch onChange={this.handleAddUVPrintServicesChange} checked={this.state.addUVPrintServices} />
                              </Col>
                            </Row>
                          </Container>
                        }
                        {this.state.addUVPrintServices &&
                          <Container className="px-1">
                            <hr />
                            <h6><b>Choose Custom UV Services</b></h6>
                            {this.state.selectedUVPrints.map((object, index) => (
                              <div key={"uvProduct"+index}>
                                <FormGroup row className="py-2">
                                  <Col className="col" md={4}>
                                    <label className="col-form-label w-100">
                                      <Container>
                                        <Row>
                                          {this.state.selectedUVPrints.length > 1 &&
                                            <Col md={"auto"} className="text-center" onClick={e => this.minusUVSideCounts(index)}>
                                              <FontAwesomeIcon className="fa-lg" icon={faTrash} color="#41464b" />
                                            </Col>
                                          }
                                          <Col className="p-0">
                                            <span className='p-1 bg-secondary text-white' style={{borderRadius: "5px"}}>
                                              <b>UV Service {index+1}</b>
                                            </span>
                                          </Col>
                                        </Row>
                                      </Container>
                                    </label>
                                    <Select
                                      key="uvPrint"
                                      name="uvPrint"
                                      isClearable={true} //teest
                                      value={object.id ? { value: object.id, label: this.getBoxSideLabel(object.box_side) } : null}
                                      onChange={e => this.handleUVPrintChangeSelect(e, index)}
                                      options={this.getUVOptions()}
                                    />
                                  </Col>
                                  {this.getUVSideBoxDesigns(index).length > 0 &&
                                    <Col className="col" md={8}>
                                      <label className="col-form-label w-100">
                                        <Container>
                                          <Row>
                                            <Col className="p-0">
                                              <h6 className='mb-0'><b>Select UV Service Template {index+1}</b></h6>
                                            </Col>
                                          </Row>
                                        </Container>
                                      </label>
                                      <Select
                                        key="boxUvDesigns"
                                        name="boxUvDesigns"
                                        isClearable={true}
                                        // value={this.getUVSelectedValue(index)}
                                        value={object.TEMPLATE_SELECT ? {value: object.TEMPLATE_SELECT.id, label: object.TEMPLATE_SELECT.name} : null}
                                        onChange={e => this.handleUVPrintTemplateChangeSelect(e, index)}
                                        options={this.getUVSideBoxDesigns(index)}
                                      />
                                      {object.TEMPLATE_SELECT && (
                                        <div className="mt-2 d-flex align-items-start">
                                          {object.TEMPLATE_SELECT.document_url && (
                                            <div className="flex-shrink-0 mr-3 text-center" style={{ width: 90 }}>
                                              <PdfPreview
                                                file={object.TEMPLATE_SELECT.document_url}
                                                thumbnailWidth={80}
                                                title={object.TEMPLATE_SELECT.name}
                                                noModal
                                              />
                                              <div className="mt-1" style={{ lineHeight: 1.2, wordBreak: 'break-word' }}>
                                                <small className="text-muted">{object.TEMPLATE_SELECT.name}</small>
                                              </div>
                                            </div>
                                          )}
                                          <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                            {(object.TEMPLATE_SELECT.gloss_layer === "Yes" || object.TEMPLATE_SELECT.white_layer === "Yes" || object.TEMPLATE_SELECT.color_layer === "Yes") && (
                                              <div className="text-muted mb-1">
                                                <small>This UV Template has: </small>
                                                {object.TEMPLATE_SELECT.gloss_layer === "Yes" && (
                                                  <span className="badge badge-info ml-1">RDG Gloss Spot Color</span>
                                                )}
                                                {object.TEMPLATE_SELECT.white_layer === "Yes" && (
                                                  <span className="badge badge-secondary ml-1">RDG White Spot Color</span>
                                                )}
                                                {object.TEMPLATE_SELECT.color_layer === "Yes" && (
                                                  <span className="badge badge-warning ml-1">CMYK Color</span>
                                                )}
                                              </div>
                                            )}
                                            <div className="p-2" style={{backgroundColor: '#e7f3ff', borderRadius: '4px', border: '1px solid #b8daff'}}>

                                                {(object.TEMPLATE_SELECT.gloss_layer === "Yes" || object.TEMPLATE_SELECT.white_layer === "Yes" || object.TEMPLATE_SELECT.color_layer === "Yes") && (
                                                  <div style={{paddingBottom: '12px', float: 'left', fontSize: '10px'}}><strong>My Box Job will have:</strong></div>
                                                )}
                                                {(object.TEMPLATE_SELECT.gloss_layer === "No" && object.TEMPLATE_SELECT.white_layer === "No" && object.TEMPLATE_SELECT.color_layer === "No") && (
                                                  <small><strong>This UV Design Template does not have RDG Gloss, RDG White Spot Color, or CMYK Color</strong></small>
                                                )}
                                                {object.TEMPLATE_SELECT.gloss_layer === "Yes" && (
                                                  <FormGroup check inline className="ml-2 mb-0">
                                                    <Label check>
                                                      <Input
                                                        type="checkbox"
                                                        id={"hasGloss-" + index}
                                                        checked={object.has_gloss || false}
                                                        onChange={e => this.handleUVPrintLayerCheckboxChange(e, index, 'has_gloss')}
                                                      />
                                                      RDG Gloss Spot Color
                                                    </Label>
                                                  </FormGroup>
                                                )}
                                                {object.TEMPLATE_SELECT.white_layer === "Yes" && (
                                                  <FormGroup check inline className="ml-2 mb-0">
                                                    <Label check>
                                                      <Input
                                                        type="checkbox"
                                                        id={"hasWhite-" + index}
                                                        checked={object.has_white || false}
                                                        onChange={e => this.handleUVPrintLayerCheckboxChange(e, index, 'has_white')}
                                                      />
                                                      RDG White Spot Color
                                                    </Label>
                                                  </FormGroup>
                                                )}
                                                {object.TEMPLATE_SELECT.color_layer === "Yes" && (
                                                  <FormGroup check inline className="ml-2 mb-0">
                                                    <Label check>
                                                      <Input
                                                        type="checkbox"
                                                        id={"hasColor-" + index}
                                                        checked={object.has_color || false}
                                                        onChange={e => this.handleUVPrintLayerCheckboxChange(e, index, 'has_color')}
                                                      />
                                                      CMYK Color
                                                    </Label>
                                                  </FormGroup>
                                                )}
                                                {(object.TEMPLATE_SELECT.gloss_layer === "Yes" || object.TEMPLATE_SELECT.white_layer === "Yes" || object.TEMPLATE_SELECT.color_layer === "Yes") && (
                                                  <div className="alert alert-warning m-1 p-2" style={{fontSize: '0.65rem'}}>
                                                    Make sure these checkboxes are correctly set to ensure your print results are as desired.
                                                  </div>
                                                )}
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </Col>
                                  }
                                  {this.getUVSideBoxDesigns(index).length === 0 && object.box_side &&
                                    <Col className="col" md={8}>
                                      <label className="col-form-label w-100">
                                        <Container>
                                          <Row>
                                            <Col className="p-0">
                                              <h6 className='mb-1'><b>No UV Design Templates found for Box Side {object.box_side}</b></h6>
                                              <FontAwesomeIcon className="fa-lg m-2 float-right" icon={faSync} color="#41464b" onClick={this.fetchUVDesigns} title="Refresh UV Design Templates" />
                                              <a key="addUVDesign" className="btn btn-sm btn-outline-primary my-2" href={`/box-uv-designs/new?boxSide=${object.box_side}&boxType=${object.enclosure_type}`} target="_blank" title={`Add UV Design Template for Box Side ${object.box_side}`} rel="noreferrer">+ Add UV Design Template for Box Side {object.box_side}</a>
                                              <div className="text-danger">A UV Design Template is required for this box side.</div>
                                            </Col>
                                        </Row>
                                      </Container>
                                    </label>
                                  </Col>
                                  }
                                </FormGroup>
                                { this.getFilteredUVServiceProducts(object.TEMPLATE_SELECT).map((product, idx) => {
                                  const isAvailable = this.isUVServiceProductAvailable(product, object);
                                  const unavailableReason = this.getUVServiceProductUnavailableReason(product, object);
                                  const isDisabled = !isAvailable || this.getDisabledUVPrintOptionsCheckboxes(index);

                                  return (
                                  <React.Fragment key={"serviceProduct"+index+"-"+idx}>
                                    { idx === 0 && (
                                      <Row className="mt-4">
                                        <Col>
                                          Add UV Service Options
                                        </Col>
                                      </Row>
                                    )}

                                    <FormGroup check row className={`pt-2 pb-1 ml-1 ${!isAvailable ? 'text-muted' : ''}`}>
                                      <Col className="col" md={12}>
                                        {this.getUVPrintOptionsCheckboxes(index, product) === true && isAvailable &&
                                          <Input id={"extra-" + product.name + "-layer-" + index} type="checkbox" onChange={e => this.handleUVPrintOptionsCheckboxesChange(e, product.name, index, product)} defaultChecked={true} disabled={isDisabled} />
                                        }
                                        {(this.getUVPrintOptionsCheckboxes(index, product) === false || !isAvailable) &&
                                          <Input id={"extra-" + product.name + "-layer-" + index} type="checkbox" onChange={e => this.handleUVPrintOptionsCheckboxesChange(e, product.name, index, product)} defaultChecked={false} disabled={isDisabled} />
                                        }
                                        <label htmlFor={"extra-" + product.name + "-layer-" + index} className={`col-form-label p-0 ${!isAvailable ? 'text-muted' : ''}`}>
                                          {product.name}
                                          {!isAvailable && unavailableReason && (
                                            <>
                                              <FontAwesomeIcon
                                                id={"uvServiceUnavailable-" + product.id + "-" + index}
                                                className="fa-sm ml-1 text-warning"
                                                icon={faInfoCircle}
                                                style={{cursor: 'pointer'}}
                                              />
                                              <UncontrolledTooltip placement="right" target={"uvServiceUnavailable-" + product.id + "-" + index}>
                                                {unavailableReason}
                                              </UncontrolledTooltip>
                                            </>
                                          )}
                                          {isAvailable && product.snippet && (
                                            <>
                                              <FontAwesomeIcon
                                                id={"uvServiceSnippet-" + product.id + "-" + index}
                                                className="fa-sm ml-1 text-info"
                                                icon={faInfoCircle}
                                                style={{cursor: 'pointer'}}
                                              />
                                              <UncontrolledTooltip placement="right" target={"uvServiceSnippet-" + product.id + "-" + index}>
                                                {product.snippet}
                                              </UncontrolledTooltip>
                                            </>
                                          )}
                                        </label>
                                      </Col>
                                    </FormGroup>
                                  </React.Fragment>
                                )})}
                                {index < (this.state.selectedUVPrints.length - 1) && <hr />}
                              </div>
                            ))}
                            <hr />
                            <Row className="py-3">
                              <Col className="text-center">
                                <Button onClick={e => this.addUVSideCounts()}>+ Add UV Printing to Box Side</Button>
                              </Col>
                            </Row>
                          </Container>
                        }
                      </Col>
                    </Row>
                  </>
                  }
                  {this.state.selectedEnclosureProduct.id !== "" && (
                    <div>
                      <h5 className="row p-2 bg-secondary text-white mb-0">3. Box Job Template Name<span style={{color: "red"}}>*</span></h5>
                      <Row className="pb-3" style={{border: "1px solid hsl(0,0%,80%)"}}>
                        <Col md="12">
                        <FormGroup row>
                          <Col className="col mt-3" md={12}>
                            <Input
                              key="configurationName"
                              id="configurationName"
                              name="configurationName"
                              placeholder="Box Job Template Name"
                              onChange={this.handleInputChange}
                              value={this.state.configurationName}
                            />
                          </Col>
                        </FormGroup>
                        </Col>
                        <Col className="mt-2" md={12}>
                          <Alert color="danger" isOpen={this.state.showAlert} toggle={this.state.toggleAlert}>{this.state.alertMsg}</Alert>
                          <Alert color="success" isOpen={this.state.showSuccess}>
                            {this.state.successMsg}
                            <div className="mt-2">
                              <Link to="/my-box-configurations" className="btn btn-sm btn-outline-success mr-2">Go to Box Job Templates</Link>
                            </div>
                          </Alert>
                          <div className="text-right">
                            <Button color="success" onClick={e => this.handleClick(e)}>Save Box Job Template</Button>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  )}
                </Col>

                <Col className="col px-0" md={5}>
                  <div className='ml-4' style={{position: "sticky", top: "66px", border: "1px solid hsl(0,0%,80%)"}}>
                    <h2 className="p-2 text-white" style={{backgroundColor: "#89CFF0"}}>Products</h2>

                    <FormGroup row>
                      <Col className="col" md={12}>
                        <Container>
                          {this.state.selectedProducts.length > 0 && this.state.selectedProducts.map((product, index) => (product && (
                            <div key={`selected` + index}>
                            <div>
                              <Row className="py-0 justify-content-center align-items-center">
                                <Col md={4} className="text-center">
                                  {product.small_image_url &&
                                    <img src={product.small_image_url} className="mx-1 w-100" alt={product.name} style={{maxWidth: "80px"}} />
                                  }
                                </Col>
                                <Col>
                                  <div>
                                    {product.sku} {product.name}
                                    {product.snippet && (
                                      <>
                                        <FontAwesomeIcon
                                          id={"orderSnippet-" + product.id + "-" + index}
                                          className="fa-sm ml-1 text-info"
                                          icon={faInfoCircle}
                                          style={{cursor: 'pointer'}}
                                        />
                                        <UncontrolledTooltip placement="right" target={"orderSnippet-" + product.id + "-" + index}>
                                          {product.snippet}
                                        </UncontrolledTooltip>
                                      </>
                                    )}
                                  </div>
                                  <div>{product["TEMPLATE_SELECT"] ? "- " +  product["TEMPLATE_SELECT"].name : ""}</div>
                                  {product["SERVICE_SELECT"] && product["SERVICE_SELECT"].map((service, svcIndex) => (service && (
                                    <div key={"service-" + svcIndex}>
                                      <span style={{textTransform: "capitalize"}}>{"- " + service.name}</span>
                                      {service.snippet && (
                                        <>
                                          <FontAwesomeIcon
                                            id={"serviceSnippet-" + product.id + "-" + svcIndex}
                                            className="fa-sm ml-1 text-info"
                                            icon={faInfoCircle}
                                            style={{cursor: 'pointer'}}
                                          />
                                          <UncontrolledTooltip placement="right" target={"serviceSnippet-" + product.id + "-" + svcIndex}>
                                            {service.snippet}
                                          </UncontrolledTooltip>
                                        </>
                                      )}
                                    </div>
                                  )))}
                                </Col>
                              </Row>
                            </div>
                            {index < (this.state.selectedProducts.length - 1) && <hr />}
                            </div>
                          )))}
                          <Row>
                            <Col>
                              <div className='m-2 p-2' style={{background: "silver"}}>
                                <h5 className='m-0 px-2'>
                                  Once you have selected all the products and services for your Box Job, click "Save Box Job Template" button and you will be redirected to the Box Templates page where you can Create an Order and set the quantity for one or more of your Box Templates.
                                </h5>
                              </div>
                            </Col>
                          </Row>

                        </Container>
                      </Col>
                    </FormGroup>
                    <Container className="mt-4 pb-4">
                      {this.state.reservedConfigurations.length > 0 && (
                        <div>
                          <h5 className="row p-2 bg-warning text-white mb-4">Reserved Box Jobs</h5>
                          <BoxConfigurationReservation reservedConfigurations={this.state.reservedConfigurations} boxConfigurationId={this.state.boxConfigurationId} />
                        </div>
                      )}
                    </Container>
                  </div>
                </Col>
              </Row>
            </form>
          )}
      </Container>
    )
  }
}

export default CustomerBoxConfigurationForm;